import {
  parseTime,
  fromNow as fromNowFilter,
  formatPhone as formatPhoneFilter,
  formatPhoneHide as formatPhoneHideFilter,
  formatBank as formatBankFilter,
  splitEncrypt,
} from '@/utils';


import {
  toThousands as toThousandsFilter,
  formatFloat as formatFloatFilter,
  convertCurrency as convertCurrencyFilter,
} from '@/utils/number';

import NP from 'number-precision';
/**
 * 数字默认值
 * @export
 * @param {*} val 数字
 * @returns
 */
export function numberFilter(val) {
  return val ?? '-';
}

/**
 * 格式化时间
 *
 * @export
 * @param {*} date 时间戳
 * @param {string} [pattern = 'yyyy-MM-dd HH:mm:ss'] 格式
 * @returns
 */
export function formatTime(date, pattern = 'yyyy-MM-dd HH:mm:ss') {
  if (!date) {
    return '-';
  }
  const number = Number(date);
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(number)) {
    date = number;
  }
  return parseTime(date, pattern);
}


/**
 * 相对时间
 *
 * @export
 * @param {*} time
 * @param {string} [pattern = 'yyyy-MM-dd HH:mm:ss']
 * @returns
 */
export function fromNow(time, pattern = 'yyyy-MM-dd HH:mm:ss') {
  if (!time) {
    return '-';
  }

  return fromNowFilter(time, pattern);
}


/**
 * 格式化手机
 *
 * @export
 * @param {*} phone 手机号
 * @param {string} [separator=' '] 连接符
 * @returns
 */
export function formatPhone(phone, separator = ' ') {
  if (!phone) {
    return '-';
  }

  return formatPhoneFilter(phone, separator);
}


/**
 * 隐藏部分手机号
 *
 * @export
 * @param {*} phone 手机号
 * @returns
 */
export function formatPhoneHide(phone) {
  if (!phone) {
    return '-';
  }

  return formatPhoneHideFilter(phone);
}


/**
 * 格式化银行卡 (4位一空格)
 *
 * @export
 * @param {*} val 银行卡号
 * @returns
 */
export function formatBank(val) {
  if (!val) {
    return '-';
  }

  return formatBankFilter(val);
}

/**
 * 千分位格式化-单位分
 * @param {number} num
 * @param {string} until ->>单位
 * @param {number} pos ->>保留小数位数
 */
export function toFenThousandsAndFloat(num, until = '', pos = 2, isNull = false) {
  if ((num === null || num === undefined) && isNull) {
    return '';
  }


  if ((num !== 0 && !num) || num === 0) {
    return '0.00';
  }
  const numFloat = formatFloatFilter(NP.divide(num, 100), pos);
  return `${until} ${toThousandsFilter(numFloat)}`;
}

/**
 * 千分位格式化带小数
 * @param {number} num
 */
export function toThousandsAndFloat(num, pos = 2) {
  if (num !== 0 && !num) {
    return '-';
  }
  return toThousandsFilter(formatFloatFilter(num, pos));
}

/**
 * 千分位格式化
 * @param {number} num
 */
export function toThousands(num) {
  if (num !== 0 && !num) {
    return '-';
  }
  return toThousandsFilter(num);
}


/**
 * 阿拉伯数组转中文数字
 * @param {number} num
 */
export function convertCurrency(num) {
  return convertCurrencyFilter(num);
}


/**
 * 格式化小数位
 *
 * @export
 * @param {*} val 小数
 * @param {number} [pos=2] 保留的小数位
 * @returns
 */
export function formatFloat(val, pos = 2) {
  return formatFloatFilter(val, pos);
}

/**
 * 空值处理
 */
export function formatEmptyValue(value, defaultValue = '-') {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }
  return value;
}

/**
 * 文件大小转换
 *
 * @export
 * @param {string} str 字符串
 */
export function fileSizeForma(str) {
  if (!str) {
    return '-';
  }
  if (parseFloat(str) < 1048576) {
    if (parseFloat(str) < 1024) {
      return `${str}B`;
    }
    return `${(str / 1024).toFixed(2)}KB`;
  }
  return `${(parseFloat(str) / 1048576).toFixed(2)}M`;
}


/**
 * 显示完整省市区地址信息
 *
 * @export
 * @param {*} val
 * @param {string} [provinceKey='province'] 省 key
 * @param {string} [cityKey='city'] 市 key
 * @param {string} [areaKey='area'] 区 key
 * @param {string} [addressKey='address'] 详细地址 key
 * @returns
 */
export function formatAddress(val, provinceKey = 'province', cityKey = 'city', areaKey = 'area', addressKey = 'address') {
  if (!val) {
    return '-';
  }

  const province = val[provinceKey] || '';
  const city = val[cityKey] || '';
  const area = val[areaKey] || '';
  const address = val[addressKey] || '';

  const isAllEmpty = province === '' && city === '' && area === '' && address === '';

  if (isAllEmpty) {
    return '-';
  }

  return `${province}${city}${area}${address}`;
}

/**
 * 列表/详情状态颜色
 * @param {*} status - 状态
 * @param {*} type - 状态类型
 * attr - 属性 传入 type 配合全局使用，传入color等其他在动态style里使用
 * @return {object | string}  object - style对象
 */
export function setStatusColor(status, type) {
  const list = {
    1: '#FFA040',
    2: '#FFA040',
    3: '#FFC02A',
    4: '#42D984',
    '-1': '#FF3741',
    '-2': '#C9CCD1',
    0: '#C9CCD1',
    WAIT: '#407DFF',
    PROCESSING: '#407DFF',
    SUCCESS: '#42D984',
    FAIL: '#FF3741',
    CANCEL: '#C9CCD1',
  };

  const approvalStatus = {
    1: '#FFA040',
    2: '#42D984',
    '-1': '#FF3741',
    '-2': '#C9CCD1',
    0: '#C9CCD1',
    WAIT: '#407DFF',
    REJECT: '#FF3741',
    PASS: '#42D984',
    CANCEL: '#C9CCD1',

    default: '#C9CCD1',
  };

  const cancelStatus = {
    1: '#FFA040',
    2: '#42D984',
    '-1': '#C9CCD1',
    0: '#C9CCD1',
    default: '#C9CCD1',
    WAIT: '#407DFF',
    SUCCESS: '#42D984',
    FAIL: '#FF3741',
    CANCEL: '#C9CCD1',
  };

  const statusObj = {
    default: {
      99: '#C9CCD1',
    },
    /**
     * 审核状态
     * 1、待审核 2、已通过 -1、已驳回 -2、已取消 0、取消中
     * Blue #FFA040 待审核
     * Green #42D984 已通过
     * Red #FF3741 已驳回
     * Grey4 #C9CCD1 已取消
     * Grey4 #C9CCD1 取消中
     */
    approvalStatus: { ...approvalStatus },
    /**
     * 核销状态 1、待核销 2、已核销 -1、已取消 0、取消中
     * Blue #FFA040 待核销
     * Green #42D984 已核销
     * Grey4 #C9CCD1 已取消
     * Grey4 #C9CCD1 取消中
     */
    cancelStatus: { ...cancelStatus },
    // 收款单确认状态 1、待确认 2、已确认 -1、已取消 -2、超时取消
    receiptStatus: { ...cancelStatus },
    /**
     * 付款单管理状态 1 待付款 2 付款中 3 部分付款 4 已付款 -1 付款失败  -2 已取消
     * Blue #FFA040 待付款
     * Blue #FFA040 付款中
     * Yellow #FFC02A 部分付款
     * Green #42D984 已付款
     * Red #FF3741 付款失败
     * Grey4 #C9CCD1 已取消
    */
    paymentStatus: { ...list },
    refundStatus: { ...list },
    // 账单状态
    billStatus: {
      1: '#FFA040', // 待出账
      2: '#FFA040', // 待还款
      3: '#42D984', // 已还款
    },
    // 分账
    divideStatus: {
      0: '#FFA040', // 待分账
      1: '#42D984', // 已分账
      2: '#FFA040', // 分账中
      3: '#FFA040', // 部分分账
      '-1': '#FF3741', // 分账失败
      '-2': '#C9CCD1', // 已取消
    },
    // 分账审核
    subStatus: {
      1: '#FFA040',
      2: '#42D984',
      '-1': '#FF3741',
      '-2': '#C9CCD1',
      '-3': '#FFA040',
      '-4': '#FFA040',
      0: '#FFA040',
      default: '#C9CCD1',
    },
    // 服务商管理-服务商客户 1 待实名 2 正常 3 已锁定 4 已停用 -1 已销户
    servicerStatus: {
      1: '#407DFF',
      2: '#42D984',
      3: '#FF3741',
      4: '#FFC02A',
      '-1': '#C9CCD1',
    },
    serviceIpStatus: {
      1: '#42D984',
      0: '#407DFF',
    },
    // 授信状态 ON=正常;OFF=已停用
    creditStatus: {
      ON: '#42D984',
      OFF: '#FF3741',
    },
    // 回款状态: NOT_REPAID 未回款,FULLY_REPAID 已回款, UN_CONFIRM  未确认, CONFIRM 已确认"
    repaymentStatus: {
      NOT_REPAID: '#FF3741',
      FULLY_REPAID: '#42D984',
      UN_CONFIRM: '#FF3741',
      CONFIRM: '#42D984',
    },
    // 百布账期-账单状态: NOT_REPAID 未回款,PARTIALLY_REPAID 部分回款,FULLY_REPAID 已回款
    baibuBillStatus: {
      NOT_REPAID: '#FF3741',
      PARTIALLY_REPAID: '#FFA040',
      FULLY_REPAID: '#42D984',
    },

  };
  if (type) {
    return statusObj[type][status];
  }
  return statusObj.default[99];
}

// 脱敏数据过滤
export function splitEncryptFilter(val) {
  if (!val) {
    return '-';
  }
  return splitEncrypt(val)[0];
}
